import React from 'react';
import './Content.css';

const BioContent: React.FC<SimpleContent> = ({title, body, footNote}) => {

    return (

        <div className='tileContent'>
            <h2 className='tileTitle'>{title}</h2>
            <p className='tileFootnote'>
                {footNote}
            </p>
            <p className='tileDescription'>
                {body}
            </p>
        </div>

    );
};

export default BioContent;